module.exports = __webpack_public_path__ + "assets/f269c397adbb2a7c7962f12a21edaee2.svg";